import { cva } from 'class-variance-authority';
import { FC, MouseEvent, useState } from 'react';

import { Copy, Eye, EyeClosed } from '../../assets';

export type CredentialFieldProps = {
  value?: string;
  label: string;
  onCopy?: (value: string) => void;
  secret?: boolean;
};

const credentialField = cva(
  'w-full border flex justify-between items-center group border-white-12 rounded py-4 px-3 relative gap-2 select-none',
  {
    variants: {
      canBeCopied: {
        true: 'cursor-pointer',
        false: 'cursor-default',
      },
    },
  }
);

const credentialFieldValue = cva(
  'text-white-80 transition-colors group-hover:text-white overflow-hidden text-ellipsis whitespace-nowrap',
  {
    variants: {
      hasValue: {
        false: 'text-uppercase-small uppercase',
      },
    },
  }
);

export const CredentialField: FC<CredentialFieldProps> = (props) => {
  const [isHidden, setIsHidden] = useState(!!props.secret);

  const onClickEye = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsHidden((prev) => !prev);
  };

  const shownValue = isHidden ? '••••••••••••••••••' : props.value;

  return (
    <div
      className={credentialField({ canBeCopied: !!props.onCopy && !isHidden })}
      onClick={() => props.value && !isHidden && props.onCopy?.(props.value)}
    >
      {props.value && (
        <div className="absolute bottom-full left-2 translate-y-1/2 bg-dark-green-900 px-1 text-uppercase-small uppercase text-white-80 transition-colors group-hover:text-white">
          {props.label}
        </div>
      )}
      <div className={credentialFieldValue({ hasValue: !!props.value })}>
        {props.value ? shownValue : props.label}
      </div>
      <div className="ml-auto flex items-center gap-2">
        {!isHidden && !!props.onCopy ? (
          <Copy className="h-4 w-4 flex-shrink-0 text-white-60 transition-colors hover:text-white-80" />
        ) : null}
        {props.secret ? (
          <div aria-label="Toggle visibility" onClick={onClickEye}>
            {isHidden ? (
              <EyeClosed className="h-4 w-4 flex-shrink-0 cursor-pointer text-white-60 transition-colors hover:text-white-80" />
            ) : (
              <Eye className="h-4 w-4 flex-shrink-0 cursor-pointer text-white-60 transition-colors hover:text-white-80" />
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};
